import { RightsOfUseEnum } from "@/contexts/newCampaignContext/types";
import { FormOptions } from "@repo/components/src/forms/types";
import { RightOfUse } from "@repo/graphql/gql/graphql";

export const RIGHTS_OF_USE_OPTIONS: (Omit<FormOptions, "value"> & {
  months: number;
  rightOfUseEnum: RightOfUse;
  value: RightsOfUseEnum;
})[] = [
  {
    label: "3 meses",
    value: RightsOfUseEnum.ThreeMonths,
    months: 3,
    rightOfUseEnum: RightOfUse.Limited,
  },
  {
    label: "6 meses",
    value: RightsOfUseEnum.SixMonths,
    months: 6,
    rightOfUseEnum: RightOfUse.Limited,
  },
  {
    label: "12 meses",
    value: RightsOfUseEnum.TwelveMonths,
    months: 12,
    rightOfUseEnum: RightOfUse.Limited,
  },
  {
    label: "Para siempre",
    value: RightsOfUseEnum.Forever,
    months: 0,
    rightOfUseEnum: RightOfUse.Forever,
  },
];
